//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import styled from '@emotion/styled';
import { convertStylesToStyled } from '@/_utils/utils';
import { Container, Grid, Link } from '@mui/material';
import logo from '@/assets/images/tmt_logo_hor.png';
import logoColor from '@/assets/images/tmt_logo_mark_hor_color.png';

function Footer() {
  return (
    <StyledFooterWrapper>
      <Container>
        <Grid container justifyContent="space-between" alignItems="center">
          <StyledCopyrightDiv>
            <span>Copyright ©</span> {new Date().getFullYear()} &nbsp;
            <Link href="//tmtinsights.com" target="_blank">
              TMT Insights Group, LLC
            </Link>
          </StyledCopyrightDiv>
          <StyledLogoLink href="//tmtinsights.com" target="_blank">
            <StyledLogo className="logo" src={logo} alt="TMT Insights logo" />
            <StyledLogoColor className="logoColor" src={logoColor} alt="TMT Insights logo" />
          </StyledLogoLink>
        </Grid>
      </Container>
    </StyledFooterWrapper>
  );
}

export default Footer;

const StyledFooterWrapper = styled.div(
  ({ theme }) => `
  padding: ${theme.spacing(3, 0)};
  margin-top: ${theme.spacing(6)};
  font-size: 0.9rem;
  font-weight: ${theme.typography.fontWeightMedium};
  position: relative;
  z-index: -1;
  ${convertStylesToStyled(theme.customOverrides?.Footer)}

  & a {
    opacity: 0.8;
    display: inline-flex;
    transition: color 350ms ease-in;

    &:hover {
      opacity: 1;
      text-decoration: none;
      transition: color 350ms ease-in;
    }
  }
`
);

const StyledCopyrightDiv = styled.div(
  ({ theme }) => `
  & span {
    opacity: 0.5;
  },
  & a:hover {
    color: ${theme.palette.primary.light};
  }
`
);

const StyledLogoLink = styled(Link)(
  () => `
  position: relative;
  height: 24px;
  &:hover {
    & .logo {
      opacity: 0;
      transition: ease-in opacity 350ms;
    }
    & .logoColor {
      opacity: 1;
      transition: ease-in opacity 350ms;
    }
  }
`
);

const StyledLogo = styled.img(
  ({ theme }) => `
  height: 40px;
  margin: ${theme.spacing(-1, 0)};
  opacity: 1;
  top: 0;
  right: 0;
  position: absolute;
  filter: ${theme.palette.mode === 'light' ? 'invert(1) opacity(.6)' : 'none'};
  transition: ease-in opacity 350ms, ease-in filter 350ms;
`
);

const StyledLogoColor = styled(StyledLogo)(
  ({ theme }) => `
  opacity: 0;
  filter: ${theme.palette.mode === 'light' ? 'invert(0) opacity(1)' : `none`};
  transition: ease-in opacity 350ms, ease-in filter 350ms;
`
);
